import { factoryService, getJsonRequest } from '@chilecompra/react-kit'
import { REACT_APP_REVIEWED_CONTRACTS_BASE_URL } from '../config/settings/environment'
import { normalizeDniSlashes } from '../modules/utils/normalizeForeignDni'

/**
 * Gets historical sanctions for a given seller.
 * When process type its all means that return all process type
 */
export const getHistoricalContracts = factoryService(({ dni }) => {
  return getJsonRequest(
    `${REACT_APP_REVIEWED_CONTRACTS_BASE_URL}/v1/comportamiento-contractual/lista-contratos-historico/${normalizeDniSlashes(dni)}`
  )
})
